const otherProjectsList = [
  {
    title: 'gig-job-react',
    description: 'A React application to search for gig-workers',
    link: 'https://github.com/bernardadhitya/gig-job-react',
  },
  {
    title: 'kitchen-price-react ',
    description: 'A kitchenware price comparator from major marketplaces in Indonesia with React',
    link: 'https://github.com/bernardadhitya/kitchen-price-react',
  },
  {
    title: 'death-archive-react',
    description: 'A death archive application used by hospitals with React and Postgresql',
    link: 'https://github.com/bernardadhitya/death-archive-react',
  },
  {
    title: 'klifomaya',
    description: 'VueJS-based project used to manage photography class; dashboard to assess students…',
    link: 'https://github.com/bernardadhitya/klifomaya',
  },
  {
    title: 'news-tweet-classification',
    description: 'Classify news tweets using K-Nearest Neighbor and visualize in React',
    link: 'https://github.com/bernardadhitya/news-tweet-classification',
  },
  {
    title: 'garden-react-app',
    description: 'Gardening website based on React.js',
    link: 'https://github.com/bernardadhitya/garden-react-app ',
  },
];

export default otherProjectsList;
